import { styled } from "styled-components";

import { Avatar } from "../Avatar";
import { Button } from "../Button";
import { Message } from "../Message";
import { Timestamp } from "../Timestamp";
import { Feedback } from "../Feedback";

export const Actions = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: 8,
    padding: `0 ${theme.space[5]} 0 54px`,

    [`& ${Button.Container}`]: {
      height: "unset",
      paddingTop: 7,
      paddingBottom: 7,
      marginTop: 8,
      marginRight: 8,
      whiteSpace: "normal",
      textAlign: "start",
    },
  };
});

interface ContainerProps {
  /** Whether the message has an image */
  $withImage?: boolean;
  /** Whether the message is scrollable */
  $scrollable?: boolean;
  /** Whether the message is centered */
  $center?: boolean;
}

export const SystemMessageContainer = styled.div<ContainerProps>(
  ({ $withImage, $scrollable, $center }) => {
    return {
      alignItems: $center ? "center" : undefined,
      display: "flex",

      [`& ${Avatar.Container}`]: {
        alignSelf: "flex-end",
        margin: "0 8px 4px 0",
        visibility: $withImage ? "visible" : "hidden",
      },

      [`& ${Timestamp.Container}`]: {
        alignSelf: "center",
        whiteSpace: "nowrap",
        marginLeft: 8,
        opacity: "0%",
        transition: "opacity 0.2s ease-in-out",
      },

      [`&:hover ${Timestamp.Container}`]: {
        opacity: "100%",
      },

      ...($scrollable
        ? {
            overflowX: "auto",
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",

            [`&::-webkit-scrollbar`]: {
              display: "none",
            },
          }
        : {}),
    };
  },
);

export const Content = styled.div(({ theme }) => {
  return {
    margin: theme.space[2],

    [`& ${Message.Container}`]: {
      marginBottom: theme.space[1],

      "&:last-of-type": {
        marginBottom: 0,
      },
    },
  };
});

export const SenderName = styled.div(({ theme }) => {
  return {
    marginLeft: "44px",
    color: theme.colors.grayDark,
    fontSize: 12,
    lineHeight: "17px",
  };
});

export const SystemResponseContainer = styled.div(() => {
  return {
    // Exact width of 548px so that two whole cards can show on the carousel.
    // Without max width the conversation looks bad on large screens.
    maxWidth: "548px",

    [`& ${Feedback.Container}`]: {
      marginLeft: "44px",
      // margin-right is used to not overflow the system message where timestamp is shown
      marginRight: "44px",
    },
  };
});
